export default __webpack_public_path__ + "static/media/icon-success-graphic.a75970c0.png";